import(/* webpackMode: "eager" */ "/vercel/path0/components/blog/comments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reactions"] */ "/vercel/path0/components/blog/reactions.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/blog/scroll-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialShare"] */ "/vercel/path0/components/blog/social-share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewsCounter"] */ "/vercel/path0/components/blog/views-counter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyCodeButton"] */ "/vercel/path0/components/mdx/copy-code-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pre"] */ "/vercel/path0/components/mdx/pre.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/android.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/azure.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/bash.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/commitlint.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/cpp.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/css.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/cuda.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/docker.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/drizzle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/env.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/exercism.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/express.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/fastapi.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/firebase.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/flask.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/gcp.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/git.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/github.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/goodreads.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/headlessui.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/html5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/hydrogen.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/imdb.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/java.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/javascript.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/jsonwebtokens.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/koa.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/kotlin.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/liquid.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/lua.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/markdown.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/matlab.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/mongodb.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/mysql.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/nestjs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/nextjs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/nodejs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/npm.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/openai.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/picsum.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/pnpm.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/postcss.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/prisma.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/pygame.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/python.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/railway.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/react.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/redis.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/remix.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/rottentomatoes.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/semanticui.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/shopify.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/spotify.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/tailwind.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/tensorflow.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/turborepo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/typescript.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/umami.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/unity.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/vercel.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/vscode.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/icons/webpack.svg");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
